import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-section">
          <h2>Bomander Travels</h2>
          <p>Your trusted partner for visas, study abroad & global travel.</p>
        </div>

        {/* LINKS */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/services">Services</Link>
          <Link to="/reviews">Reviews</Link>
          <Link to="/contact">Contact</Link>
        </div>

        {/* CONTACT */}
        <div className="footer-section">
          <h3>Contact</h3>
          <p><FaEnvelope className="icon email-icon" /> admin@bomander.com</p>
          <p><FaWhatsapp className="icon whatsapp-icon" /> +2348103336533</p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 Bomander Travels Limited. All rights reserved.</p>
      </div>

    </footer>
  );
}

export default Footer;